const sum = (acc, cur) => (acc += cur)
const progressUpdateSaved = actuals => Object.values(actuals).reduce(sum, 0)

export default progressUpdateSaved



// WEBPACK FOOTER //
// ./src/utils/progressUpdateSaved.js